import { NavLink } from 'react-router-dom';
import { forwardRef } from 'react';

const NavLinkAdapter = forwardRef(({ className, ...props }, ref) => {
	return (
		<NavLink
			className={({ isActive }) => {
				// Filter out falsy values and join with space
				return [className, isActive ? 'active' : ''].filter(Boolean).join(' ');
			}}
			ref={ref}
			{...props}
		/>
	);
});

NavLinkAdapter.displayName = 'NavLinkAdapter';

export default NavLinkAdapter;
